import { reactive } from 'vue';
import { getRepairEquipmentList } from '@/request/view/repair';

export const repairList = reactive({
    tableData: [],
    loading: false,
    page: {
        lineNum: 10,
        pageNum: 1,
        total: 0,
    },
    requestPayload: {
        userId: null,
        repairProcessType: null,
        serial: null,
        serialType: null,
    }
});

/**
 * 获取返修记录列表
*/
export const getRepairListData = () => {
    repairList.loading = true;
    getRepairEquipmentList({
        lineNum: repairList.page.lineNum,
        pageNum: repairList.page.pageNum,
        serial: repairList.requestPayload.serial,
        serialType: repairList.requestPayload.serialType,
        repairProcessType: repairList.requestPayload.repairProcessType,
        userId: repairList.requestPayload.userId,
    })
        .then((res) => {
            if (res.code === 200 && res.message === "成功") {
                repairList.tableData.length = 0;
                repairList.tableData.push(...res.data.records);
                repairList.page.total = res.data.total;
                console.log(repairList.page, '这是什么');
            }
            repairList.loading = false;
        }).catch((err) => {
            repairList.loading = false;
        });
};

/**
 * 分页
*/
export const handleUpdatePage = (page, size) => {
    if (page) repairList.page.pageNum = page;
    if (size) repairList.page.lineNum = size;
}

/**
 * 修改请求参数
 * @params { requestPayload.userId } 登录的用户id
 * @params { requestPayload.serial } 设备序列号
 * @params { requestPayload.serialType } 设备类型
 * @params { requestPayload.repairProcessType } 返修进度
*/
export const handleUpdateRequestPayload = (requestPayload) => {
    const { userId, serial, serialType, repairProcessType } = requestPayload;
    if (userId) repairList.requestPayload.userId = userId;
    if (serial) repairList.requestPayload.serial = serial;
    if (serialType) repairList.requestPayload.serialType = serialType;
    if (repairProcessType) repairList.requestPayload.repairProcessType = repairProcessType;
}
